// const Progress = ({ value }) => {
//     return (
//         <div className="progress">
//             <span className="progress--line" style={{ width: value }}></span>
//             {parseInt(value) % 10 === 0 && parseInt(value) !== 0 ? (
//                 <span
//                     className="progress--indicator"
//                     style={{ left: `calc(${value} - 25px)` }}
//                 >
//                     {value}
//                 </span>
//             ) : null}
//         </div>
//     );
// };

// export default Progress;

const Progress = ({ value }) => {
    const parsed = parseInt(value);
  
    return (
      <div className="progress">
        <span className="progress--line" style={{ width: `${parsed}%` }}></span>
        {parsed > 0 && (
          <span
            className="progress--indicator"
            style={{ left: `calc(${parsed}% - 25px)` }}
          >
            {`${parsed}%`}
          </span>
        )}
      </div>
    );
  };
  
  export default Progress;
  